export default {
	 'Internal Server Error': 'Er is een onbekende fout opgetreden. Probeer opnieuw of neem contact op. ',
	 'Unprocessable Entity': 'Ongeldige aanvraag',
	 cloudhints: {
		error_try_again: 'Wijziging niet opgeslagen. Probeer a.u.b. opnieuw!', 
		forgot_pass: 'Wachtwoord vergeten?',
		request_new_pass: 'Stuur mij een nieuw wachtwoord',
		back_to_login: 'Terug naar inloggen',
		pass_send: 'Een wachtwoord is verstuurd naar uw e-mailadres. Controleeer a.u.b. uw spam folder.',
		reset_pass_error: 'Aanvraag mislukt. Probeer opnieuw en controleer de geldigheid van uw e-mailadres.',
		registration_error: 'Registreren mislukt. Controleer de geldigheid van uw gegevens en probeer opnieuw.',
		login_error: 'Inloggen mislukt. Controleer de geldigheid van uw gegevens',
		unkown_request: 'Onbekende aanvraag',
		new_account: 'Maak een account',
		save: 'Opslaan',
		save_next: 'Opslaan en volgende',
		back_to_ads: 'Terug naar advertenties',
	 },
	 ads: {
		min_bid_invalid: 'Bieding voldoet niet aan de minimale CPC', 
		bid_stepsize: 'Bieding moet afgerond worden op € 0,25. Bijvoorbeeld 2,00 of 2,25 of 2,50.',
		ad_created: 'Advertentie toegevoegd. Ga naar \'Mijn advertenties\' om uw advertenties te beheren.'
	 },	 
	 aor: {
        action: {
            delete: 'Verwijderen',
            show: 'Tonen',
            list: 'Lijst',
            save: 'Opslaan',
            create: 'Nieuw',
            edit: 'Wijzigen',
            cancel: 'Annuleren',
            refresh: 'Vernieuwen',
            add_filter: 'Filter toevoegen',
            remove_filter: 'Verwijder deze filter',
            back: 'Terug',
        },
        boolean: {
            true: 'Ja',
            false: 'Nee',
        },
        page: {
            list: '%{name} lijst',
            edit: '%{name} #%{id}',
            show: '%{name} #%{id}',
            create: 'Nieuw %{name}',
            delete: 'Verwijder %{name} #%{id}',
            dashboard: 'Dashboard',
            not_found: 'Niet gevonden',
        },
        input: {
            autocomplete: {
                none: 'Geen',
            },
            file: {
                upload_several:
                    'Drop bestanden om te uploaden, of klik om te selecteren.',
                upload_single: 'Drop een bestand om te uploaden, of klik om te selecteren.',
            },
            image: {
                upload_several:
                    'Drop een afbeelding om te uploaden, of klik om te selecteren.',
                upload_single:
                    'Drop een afbeelding om te uploaden, of klik om te selecteren.',
            },
            references: {
                all_missing: 'Geassocieerde data niet gevonden.',
                many_missing:
                    'Één of meerdere associaties kunnen niet meer gevonden worden.',
                single_missing:
                    'Associatie kan niet gevonden worden.',
            },
        },
        message: {
            yes: 'Ja',
            no: 'Nee',
            are_you_sure: 'Weet u het zeker?',
            about: 'Over',
            not_found:
                'Deze pagina kan niet gevonden worden..',
        },
        navigation: {
            no_results: 'Geen resultaten gevonden',
            no_more_results:
                'De pagina met nummer %{page} is niet beschikbaar. Probeer een vorige pagina. ',
            page_out_of_boundaries: 'Pagina nummer %{page} is uit bereik.',
            page_out_from_end: 'Het is niet mogelijk voorbij de laatste pagina te gaan.',
            page_out_from_begin: 'Het is niet mogelijk voor de eerste pagina te gaan.',
            page_range_info: '%{offsetBegin}-%{offsetEnd} van %{total}',
            next: 'Volgende',
            prev: 'Vorige',
        },
        auth: {
			email: 'E-mailadres',		
			sign_in: 'Inloggen',
			password: 'Wachtwoord',	
			company_name: 'Bedrijfsnaam',
			company_site: 'Website (inclusief https://)',
			sign_up: 'Registreren',
			logout: 'Uitloggen',			
            username: 'Gebruikersnaam (e-mail)',
            sign_in_error: 'Authenticatie mislukt, probeer a.u.b. opnieuw',
        },
        notification: {
            updated: 'Wijzigingen bewaard',
            created: 'Wijzigingen bewaard',
            deleted: 'Verwijderen voltooid',
            item_doesnt_exist: 'Dit element bestaat niet',
            http_error: 'Error bij het communiceren met de server',
            bad_item: 'Dit element is niet geldig',
        },
        validation: {
            required: 'Verplicht',
            minLength: 'Veld moet minimaal %{min} karakters bevatten',
            maxLength: 'Veld moet minimaal %{max} karakters bevatten',
            minValue: 'Waarde moet minimaal %{min} zijn',
            maxValue: 'Waarde moet %{max} zijn, of lager',
            number: 'Waarde moet een nummer zijn',
            email: 'Waarde moet een geldig e-mailadres zijn',
        },
    },
};



// WEBPACK FOOTER //
// ./src/i18n/nl.js